<template>
  <div>
    <v-container class="container px-0 mb-8">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col class="d-flex align-center">
          <h4 class="font-weight-light">
            {{ $t("heading.reseller.page.emailSettings") }}
          </h4>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="email-settings px-0 py-0">
      <v-form ref="form" v-model="formValid" lazy-validation>
        <v-card elevation="4" class="mb-8">
          <div class="email-settings__container py-6 px-6">
            <v-row v-for="(row, rowIndex) in fieldSections.basic.rows" :key="`basic-${rowIndex}`" no-gutters>
              <v-col
                v-for="field in row"
                :key="field.name"
                :cols="field.cols || 12"
                :sm="field.sm"
              >
                <div class="d-flex align-center gray--text text--darken-4 mb-2">
                  <label class="mb-0 d-flex align-center p-sm">
                    {{ field.label }}
                    <!-- <v-tooltip
                      bottom
                      :offset-y="10"
                      open-delay="150"
                      close-delay="150"
                      max-width="300px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="ml-2"
                          color="gray lighten-1"
                          size="16"
                        >
                          $help
                        </v-icon>
                      </template>
                      <span class="gray--text text--darken-2">
                        {{ field.tooltip }}
                      </span>
                    </v-tooltip> -->
                </label>
                </div>
                <v-skeleton-loader
                  v-if="fetching"
                  type="list-item"
                ></v-skeleton-loader>
                <v-select
                  v-else-if="field.type === 'select'"
                  :items="field.options"
                  v-model="settings[field.name]"
                  :placeholder="field.placeholder"
                  outlined
                  hide-details="auto"
                  class="mb-0"
                ></v-select>
                <v-text-field
                  v-else-if="field.type === 'password'"
                  type="password"
                  v-model="settings[field.name]"
                  :placeholder="field.placeholder"
                  outlined
                  hide-details="auto"
                  class="mb-0"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="settings[field.name]"
                  :placeholder="field.placeholder"
                  outlined
                  hide-details="auto"
                  class="mb-0"
                ></v-text-field>
              </v-col>
            </v-row>

             <div class="email-settings__configuration-container">
                 <h6 class="mb-0 font-weight-light">{{ fieldSections.server.title }}</h6>
                 <v-row v-for="(row, rowIndex) in fieldSections.server.rows" :key="`server-${rowIndex}`" no-gutters>
                   <v-col
                     v-for="field in row"
                     :key="field.name"
                     :cols="field.cols || 12"
                     :sm="field.sm"
                   >
                     <div class="d-flex align-center gray--text text--darken-4 mb-2">
                       <label class="mb-0 d-flex align-center p-sm">
                         {{ field.label }}
                         <!-- <v-tooltip
                           bottom
                           :offset-y="10"
                           open-delay="150"
                           close-delay="150"
                           max-width="300px"
                         >
                           <template v-slot:activator="{ on, attrs }">
                             <v-icon
                               v-bind="attrs"
                               v-on="on"
                               class="ml-2"
                               color="gray lighten-1"
                               size="16"
                             >
                               $help
                             </v-icon>
                           </template>
                           <span class="gray--text text--darken-2">
                             {{ field.tooltip }}
                           </span>
                         </v-tooltip> -->
                       </label>
                     </div>
                     <v-skeleton-loader
                       v-if="fetching"
                       type="list-item"
                     ></v-skeleton-loader>
                     <v-select
                       v-else-if="field.type === 'select'"
                       :items="field.options"
                       v-model="settings[field.name]"
                       :placeholder="field.placeholder"
                       outlined
                       hide-details="auto"
                       class="mb-0"
                       :menu-props="{
                        offsetY: true,
                        nudgeBottom: '8px',
                        }"
                     ></v-select>
                     <v-text-field
                       v-else-if="field.type === 'password'"
                       type="password"
                       v-model="settings[field.name]"
                       :placeholder="field.placeholder"
                       outlined
                       hide-details="auto"
                       class="mb-0"
                     ></v-text-field>
                     <v-text-field
                       v-else
                       v-model="settings[field.name]"
                       :placeholder="field.placeholder"
                       outlined
                       hide-details="auto"
                       class="mb-0"
                     ></v-text-field>
                   </v-col>
                 </v-row>
                 <div class="email-settings__configuration-action">
                     <v-btn
                       :loading="testingConnection"
                       color="primary"
                       outlined
                       @click="testConnection"
                       large
                     >
                       {{ $t("button.testConnection") }}
                     </v-btn>
                     <v-btn
                       color="primary"
                       outlined
                       @click="$refs.SendTestEmailModal.open()"
                       large
                     >
                       {{ $t("button.sendTestEmail") }}
                     </v-btn>
                 </div>
             </div>
          </div>
        </v-card>

        <!-- Save Changes Button -->
        <v-btn
          :loading="submitting"
          color="primary"
          elevation="0"
          @click="submit"
          large
        >
          {{ $t("button.saveChanges") }}
        </v-btn>
      </v-form>
    </v-container>
    <SendTestEmailModal ref="SendTestEmailModal" :settings="settings" />
  </div>
</template>

<script>
import Api from "../../apis/Api";
import SendTestEmailModal from "./SendTestEmailModal.vue";

export default {
  components: {
    SendTestEmailModal,
  },
  props: {},
  data() {
    return {
      formValid: true,
      settings: {
        from_name: "",
        from_email: "",
        copy_to: "",
        blind_copy_to: "",
        smtp_host: "",
        smtp_port: "",
        smtp_username: "",
        smtp_password: "",
        smtp_ssl_type: "",
      },
      fields: [
        {
          name: "from_name",
          label: this.$t("reseller.emailSettings.fromName"),
          tooltip: this.$t("reseller.emailSettings.fromName.tooltip"),
          placeholder: this.$t("reseller.emailSettings.fromName.placeholder"),
          section: "basic",
          newRow: true,
          cols: 12,
          sm:6
        },
        {
          name: "from_email",
          label: this.$t("reseller.emailSettings.fromEmail"),
          tooltip: this.$t("reseller.emailSettings.fromEmail.tooltip"),
          placeholder: this.$t("reseller.emailSettings.fromEmail.placeholder"),
          section: "basic",
          cols: 12,
          sm:6
        },
        {
          name: "copy_to",
          label: this.$t("reseller.emailSettings.copyTo"),
          tooltip: this.$t("reseller.emailSettings.copyTo.tooltip"),
          placeholder: this.$t("reseller.emailSettings.copyTo.placeholder"),
          section: "basic",
          newRow: true,
          cols: 12,
          sm:6
        },
        {
          name: "blind_copy_to",
          label: this.$t("reseller.emailSettings.blindCopyTo"),
          tooltip: this.$t("reseller.emailSettings.blindCopyTo.tooltip"),
          placeholder: this.$t(
            "reseller.emailSettings.blindCopyTo.placeholder"
          ),
          section: "basic",
          cols: 12,
          sm:6
        },
        {
          name: "smtp_host",
          label: this.$t("reseller.emailSettings.smtpHost"),
          tooltip: this.$t("reseller.emailSettings.smtpHost.tooltip"),
          placeholder: this.$t("reseller.emailSettings.smtpHost.placeholder"),
          section: "server",
          newRow: true,
          cols: 6,
          sm:3,
        },
        {
          name: "smtp_port",
          label: this.$t("reseller.emailSettings.smtpPort"),
          tooltip: this.$t("reseller.emailSettings.smtpPort.tooltip"),
          placeholder: this.$t("reseller.emailSettings.smtpPort.placeholder"),
          section: "server",
          cols: 6,
          sm:3
        },
        {
          name: "smtp_username",
          label: this.$t("reseller.emailSettings.smtpUsername"),
          tooltip: this.$t("reseller.emailSettings.smtpUsername.tooltip"),
          placeholder: this.$t(
            "reseller.emailSettings.smtpUsername.placeholder"
          ),
          section: "server",
          cols: 6,
          sm:3
        },
        {
          name: "smtp_password",
          label: this.$t("reseller.emailSettings.smtpPassword"),
          tooltip: this.$t("reseller.emailSettings.smtpPassword.tooltip"),
          placeholder: this.$t(
            "reseller.emailSettings.smtpPassword.placeholder"
          ),
          type: "password",
          section: "server",
          cols: 6,
          sm:3
        },
        {
          name: "smtp_ssl_type",
          label: this.$t("reseller.emailSettings.smtpSslType"),
          tooltip: this.$t("reseller.emailSettings.smtpSslType.tooltip"),
          placeholder: this.$t(
            "reseller.emailSettings.smtpSslType.placeholder"
          ),
          type: "select",
          options: [
            { value: "none", text: this.$t("general.none") },
            { value: "ssl", text: "SSL" },
            { value: "tls", text: "TLS" },
          ],
          section: "server",
          newRow: true,
          cols: 12,
        },
      ],
      fetching: false,
      submitting: false,
      testingConnection: false,
    };
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    fetchSettings() {
      this.fetching = true;
      Api.get(`/reseller/email-settings`)
        .then((response) => {
          this.settings = {
            from_name: response.data.data.from_name,
            from_email: response.data.data.from_email,
            copy_to: response.data.data.copy_to,
            blind_copy_to: response.data.data.blind_copy_to,
            smtp_host: response.data.data.smtp_host,
            smtp_port: response.data.data.smtp_port,
            smtp_username: response.data.data.smtp_username,
            smtp_password: response.data.data.smtp_password,
            smtp_ssl_type: response.data.data.smtp_ssl_type,
          };
        })
        .catch((error) => {
          console.error(error);
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.submitting = true;
      Api.put(`/reseller/email-settings`, this.settings)
        .then(() => {
          this.$store.dispatch("addAlert", {
            success: true,
            successMessage: this.$t("message.alertManager.success"),
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    testConnection() {
      this.testingConnection = true;
      Api.post(`/reseller/email-settings/test-connection`, this.settings)
        .then((response) => {
          if (response.data.success) {
            this.$store.dispatch("addAlert", {
              success: true,
              successMessage: this.$t("message.alertManager.success"),
            });
            return;
          }
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: response.data.message,
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.testingConnection = false;
        });
    },
  },
  watch: {},
  computed: {
    fieldSections() {
      const sections = {
        basic: {
          title: "",
          rows: [],
        },
        server: {
          title: "Mail Server Configuration",
          rows: [],
        },
      };
      
      // Group fields by section and then by rows
      Object.keys(sections).forEach((sectionKey) => {
        const sectionFields = this.fields.filter(
          (field) => field.section === sectionKey
        );
        
        let currentRow = [];
        sectionFields.forEach((field) => {
          if (field.newRow && currentRow.length > 0) {
            sections[sectionKey].rows.push(currentRow);
            currentRow = [];
          }
          currentRow.push(field);
        });
        
        if (currentRow.length > 0) {
          sections[sectionKey].rows.push(currentRow);
        }
      });
      
      return sections;
    },
  },
};
</script>

<style lang="scss">
    .email-settings {
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        &__container {
            display: flex;
            flex-direction: column;
            row-gap: 16px;
            label{
                color: map-get($gray, darken1);
                font-weight: 600;
                line-height: 24px;
            }
        }
        &__configuration-container {
            display: flex;
            flex-direction: column;
            row-gap: 16px;
            padding: 16px 16px 24px 16px;
            border: 1px solid var(--v-gray-lighten2);
            border-radius: 8px;
            background: #FCFCFF;
            h6{
                font-size: 18px;
                line-height: 24px;
            }
        }
        &__configuration-action {
            display: flex;
            gap: 16px;
            @media(max-width: 480px) {
                flex-direction: column;
            }
        }
        .row.no-gutters {
            row-gap: 16px;
            margin-left: -6px !important;
            margin-right: -6px !important;
            
            > .col,
            > [class*="col-"] {
              padding-left: 6px !important;
              padding-right: 6px !important;
            }
        }
    }
    .theme--dark{
        .email-settings {
            &__configuration-container {
                background: var(--v-gray-lighten5);
            }
        }
    }
</style>
